import React from 'react';
import {
	FeedbackCollectorButton,
	EntryKeys,
	ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT,
} from '@atlassian/jira-feedback-collector';
import { hideUGCProviderName } from '@atlassian/jira-software-deployments-devops-provider';
import { useProjectAnalyticsAttributes } from '@atlassian/jira-software-report-charting-common';
import { useDeploymentProviders } from '../../../services/deployment-provider';

const FEEDBACK_COLLECTOR_LOCATION = 'reports.deployment-frequency';

export const FeedbackButton = () => {
	const { data: deploymentProviders, error: errorDeploymentProviders } = useDeploymentProviders();
	const projectAttributes = useProjectAnalyticsAttributes();

	if (projectAttributes === null) {
		return null;
	}

	if (errorDeploymentProviders) {
		throw new Error(
			`Getting deployment providers failed when using useDeploymentProviders while attempting to display Deployment Frequency Report feedback button. Details: ${errorDeploymentProviders.message}`,
		);
	}
	const additionalFeedbackEntries = [
		{
			id: EntryKeys.FEEDBACK_COLLECTOR_LOCATION,
			value: FEEDBACK_COLLECTOR_LOCATION,
		},
		{
			id: EntryKeys.IS_SIMPLIFIED_PROJECT,
			value: projectAttributes.isSimplified.toString(),
		},
		{
			id: EntryKeys.IS_ADMIN,
			value: projectAttributes.isProjectAdmin.toString(),
		},
		{
			id: EntryKeys.DEPLOYMENT_PROVIDERS,
			value: deploymentProviders
				? hideUGCProviderName(deploymentProviders)
						.map((deploymentProvider) => deploymentProvider.name)
						.join(', ')
				: '',
		},
	];

	return (
		<FeedbackCollectorButton
			entrypointId={ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT}
			feedbackContext={additionalFeedbackEntries}
		/>
	);
};
